import React, { useEffect, useState, useRef, useMemo } from "react";
import ReactApexChart from "react-apexcharts";


const RadialChart = ({ totalpartsData,selectedChildPart,selectedDate}) => {
console.log("rr",totalpartsData)
  const [chartData, setChartData] = useState({
    series: [0, 0, 0],
    total: 0
 });
 const [partCounts,setPartCounts]= useState([0,0,0]);
 const [totalPartCount,setTotalPartCount]= useState(0);


 
  const getShiftProgress = () => {
    const now = new Date();
    const hour = now.getHours();
    const minute = now.getMinutes();
    const totalMinutes = hour * 60 + minute;
  
    const shift1Start = 6 * 60;    // 6:00 AM
    const shift2Start = 14 * 60;   // 2:00 PM
    const shift3Start = 22 * 60;   // 10:00 PM
  //  const shiftEnd = 6 * 60;       // 6:00 AM next day
  
   // const minutesIntoDay = (totalMinutes >= shift3Start) ? totalMinutes - shift3Start : totalMinutes;
  
    let shift1 = 0, shift2 = 0, shift3 = 0;
  
    if (totalMinutes >= shift1Start && totalMinutes < shift2Start) {
      shift1 = ((totalMinutes - shift1Start) / 480) * 100;
    } else if (totalMinutes >= shift2Start && totalMinutes < shift3Start) {
      shift1 = 100;
      shift2 = ((totalMinutes - shift2Start) / 480) * 100;
    } else if (totalMinutes >= shift3Start || totalMinutes < shift1Start) {
      // If it's between 10PM - 6AM (spans across midnight)
      shift1 = 100;
      shift2 = 100;
      if (totalMinutes >= shift3Start) {
        shift3 = ((totalMinutes - shift3Start) / 480) * 100;
      } else {
        // e.g., 3 AM = 3*60 = 180 mins past midnight
        shift3 = ((totalMinutes + (24 * 60 - shift3Start)) / 480) * 100;
      }
    }
  
    return [
      Math.min(100, Math.max(0, Math.round(shift1))),
      Math.min(100, Math.max(0, Math.round(shift2))),
      Math.min(100, Math.max(0, Math.round(shift3)))
    ];
  };

  // const getShiftProgressFromData = (shiftData) => {
  //   const parseTimeToMinutes = (timeStr) => {
  //     const [h, m, s] = timeStr.split(":").map(Number);
  //     return h * 60 + m + Math.floor(s / 60);
  //   };
  
  //   const shift1 = shiftData.shift_1 ? parseTimeToMinutes(shiftData.shift_1.machine_running_hours) : 0;
  //   const shift2 = shiftData.shift_2 ? parseTimeToMinutes(shiftData.shift_2.machine_running_hours) : 0;
  //   const shift3 = shiftData.shift_3 ? parseTimeToMinutes(shiftData.shift_3.machine_running_hours) : 0;
  //   // const count1 = shiftData.shift_1?.total_count || 0;
  //   // const count2 = shiftData.shift_2?.total_count || 0;
  //   // const count3 = shiftData.shift_3?.total_count || 0;

  // //   setPartCounts([count1, count2, count3]);
  // //   setTotalPartCount(count1 + count2 + count3);
  //   // const totalCount =
  //   // (shiftData.shift_1?.total_count || 0) +
  //   // (shiftData.shift_2?.total_count || 0) +
  //   // (shiftData.shift_3?.total_count || 0);
 
  // // console.log("totalllllll",totalPartCount)
  //   return [
  //     Math.min(100, Math.round((shift1 / 480) * 100)),
  //     Math.min(100, Math.round((shift2 / 480) * 100)),
  //     Math.min(100, Math.round((shift3 / 480) * 100)),
  //   ];
  // };

  const getShiftProgressFromData = (shiftData) => {
    const parseTimeToMinutes = (timeStr) => {
      const [h, m, s] = timeStr.split(":").map(Number);
      return h * 60 + m + Math.floor(s / 60);
    };
  
    const shift1 = shiftData.shift_1 ? parseTimeToMinutes(shiftData.shift_1.machine_running_hours) : 0;
    const shift2 = shiftData.shift_2 ? parseTimeToMinutes(shiftData.shift_2.machine_running_hours) : 0;
    const shift3 = shiftData.shift_3 ? parseTimeToMinutes(shiftData.shift_3.machine_running_hours) : 0;
  
    return [
      Math.min(100, Math.round((shift1 / 480) * 100)), // 480 mins = 8 hours
      Math.min(100, Math.round((shift2 / 480) * 100)),
      Math.min(100, Math.round((shift3 / 480) * 100)),
    ];
  };

  useEffect(() => {
    const updateShiftProgress = async () => {
      const isToday = new Date().toISOString().slice(0, 10) === selectedDate;
  
      if (isToday) {
        const series = getShiftProgress(); // live calculation
        setChartData({ series, total: series.reduce((a, b) => a + b, 0) });
        // setChartData({ series });
        // setTotalPartCount(0) 
        // setPartCounts([0,0,0]);
           } else {
        // Fetch shift data from API
        try {
          // const response = await fetch(`https://api.hanoch.in/api/shift-production-summary/?date=${selectedDate}`);
          const data = totalpartsData;
         
  
    
      
          const series = getShiftProgressFromData(data);
          setChartData({ series, total: series.reduce((a, b) => a + b, 0) });
          // setChartData({ series });
        } catch (err) {
          console.error("Error fetching shift summary:", err);
        }
      }
    };
    
    updateShiftProgress();
    const interval = setInterval(updateShiftProgress, 60 * 1000);
    return () => clearInterval(interval);
  }, [selectedDate, selectedChildPart]);
    
  // Update chart data when totalpartsData changes
  // useEffect(() => {
  //   if (totalpartsData &&  totalpartsData.shift_1 &&
  //     totalpartsData.shift_2 &&
  //     totalpartsData.shift_3 ) {
     
  //     const part_multiple = selectedChildPart;
  //     const partCounts = [
  //       totalpartsData.shift_1?.total_count*part_multiple || 0, 
  //       totalpartsData.shift_2?.total_count*part_multiple || 0, 
  //       totalpartsData.shift_3?.total_count*part_multiple|| 0
  //     ];
  
      
  //     const total = partCounts.reduce((sum, value) => sum + value, 0);
  //     setPartCounts(partCounts);
  //   setTotalPartCount(total);
  //      // Compute % for radial fill
  //   const series = partCounts.map((count) => Math.round((count / total) * 100));
  //     setChartData({ series, total });
  //    // console.log(total, 'updated total parts');
  //   }
  // }, [totalpartsData,selectedChildPart]); // This will run whenever totalpartsData changes
  

  useEffect(() => {
    if (totalpartsData && totalpartsData.shift_1 && totalpartsData.shift_2 && totalpartsData.shift_3) {
      const part_multiple = selectedChildPart;
      const partCounts = [
        (totalpartsData.shift_1?.total_count || 0) * part_multiple,
        (totalpartsData.shift_2?.total_count || 0) * part_multiple,
        (totalpartsData.shift_3?.total_count || 0) * part_multiple,
      ];
  
      const total = partCounts.reduce((sum, value) => sum + value, 0);
      setPartCounts(partCounts);
      setTotalPartCount(total);
  
      // ✅ Use machine_running_hours to set radial progress
      const series = getShiftProgressFromData(totalpartsData);
      setChartData({ series, total });
    }
  }, [totalpartsData, selectedChildPart]);

 // Store the total in a ref to ensure it's accessible in the formatter
   const totalRef = useRef(chartData.total);
  
  // Update ref when total changes
  useEffect(() => {
    totalRef.current = chartData.total;
  }, [chartData.total]);
  
  // const options = {
  //   chart: {
  //     height: 350,
  //     type: "radialBar",
  //   },
  //   plotOptions: {
  //     radialBar: {
  //       offsetY : 0,
  //       startAngle : 0,
  //       endAngle : 360,
  //       hollow: {
  //         margin: 10,
  //         size: "45%",
  //       },
  //       track: {
  //         show: true,
  //         strokeWidth: "70%",
  //         margin: 12,
  //       },
  //       dataLabels: {
  //         name: {
  //           fontSize: "20px",
            
  //         },
  //         value: {
  //           fontSize: "18px",
            
  //           // formatter: function(val) {
  //           //   return val.toString();
  //           // }
  //           formatter: function (_, { seriesIndex }) {
  //             return partCounts[seriesIndex]?.toString() || "0"; // 🟢 Show actual part count per shift
  //           },
  //         },
  //         total: {
  //           show: true,
  //           label: "Total",
  //           formatter: function () {
  //             return totalRef.current.toString();
  //            // return totalPartCount.toString(); // ✅ show actual part count here
  //           },
  //         },
  //       },
  //     },
  //   },
  //   labels: ["Shift 1", "Shift 2", "Shift 3"],
  //   colors: ["#099680", "#4aa3ff", "#5664d2"],
  //   tooltip: {
  //     enabled: true,
  //     y: {
  //       // formatter: function(value) {
  //       //   return value.toString();
  //       // }
  //       formatter: function (_, { seriesIndex }) {
  //         return `Parts: ${partCounts[seriesIndex] || 0}`; // 🟢 Tooltip shows actual part count
  //       },
  //     }
  //   }
  // };


  


  // useEffect(() => {
  //   const updateShiftProgress = () => {
  //     const series = getShiftProgress();
  //     setChartData({ series, total: series.reduce((a, b) => a + b, 0) });
  //   };
  
  //   updateShiftProgress(); // run on mount
  //   const interval = setInterval(updateShiftProgress, 60 * 1000); // update every minute
  //   return () => clearInterval(interval); // cleanup
  // }, [
  //   selectedChildPart,selectedDate,selectedMachine
  // ]);
  
  const options = useMemo(() => ({
    chart: {
      height: 350,
      type: "radialBar",
    },
    plotOptions: {
      radialBar: {
        offsetY: 0,
        startAngle: 0,
        endAngle: 360,
        hollow: {
          margin: 10,
          size: "45%",
        },
        track: {
          show: true,
          strokeWidth: "70%",
          margin: 12,
        },
        dataLabels: {
          name: {
            fontSize: "20px",
           
          },
          
        
          value: {
            fontSize: "18px",
            // color:"#FFFDF6",
            formatter: function (_, { seriesIndex }) {
              return partCounts[seriesIndex]?.toString() || "0";
            },
          },
          total: {
            show: true,
            label: "Total",
            formatter: function () {
              return totalPartCount.toString();
            },
          },
        },
      },
    },
    labels: ["Shift 1", "Shift 2", "Shift 3"],
    colors: ["#129990", "#578FCA", "#205781"],
    tooltip: {
      enabled: true,
      y: {
        formatter: function (_, { seriesIndex }) {
          return `Parts: ${partCounts[seriesIndex] || 0}`;
        },
      },
    }
  }), [partCounts, totalPartCount]);
 

  return (
    <React.Fragment>
      <ReactApexChart
  key={partCounts.join("-")}
  options={options}
  series={chartData.series}
  type="radialBar"
  height="350"
  className="apex-charts"
/>
    </React.Fragment>
  );
};

// C:\Users\Dell\Desktop\opti\build

export default RadialChart;
